<!--
 * @Description: 登录页
 * @Author: YOYO 792611446@qq.com
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @Date:   2019-04-29 14:39:19
 * @LastEditTime: 2021-12-11 09:51:16
 -->
<template>
  <div id="login">
    <!-- <div id="backgroundContainer" ref="canvas"></div> -->
    <div class="bgContainer">
      <img class="bg" :src="bgSrc" alt="" @error="bgError">
      <img class="bgPic" :src="bgPicSrc" alt="" @error="bgPicError">
    </div>
    <div class="header">
      <img :src="logoSrc" alt="" @error="logoError" />
      <span>{{ systemName }}</span>
    </div>
    <transition name="el-zoom-in-center">
      <div class="loginBox" v-if="showLoginBox">
        <h3>欢迎使用</h3>
        <el-input
          v-model="username"
          class="username"
          placeholder="请输入用户名"
          prefix-icon="iconfont iconzhanghao"
          clearable
          @keyup.enter.native="loginClickHandler"
        ></el-input>
        <el-input
          v-model="password"
          class="password"
          type="password"
          placeholder="请输入密码"
          prefix-icon="iconfont iconmima"
          clearable
          @keyup.enter.native="loginClickHandler"
        ></el-input>
        <!-- 验证码 -->
        <transition name="el-zoom-in-top">
          <div class="verificationCode" v-if="showVerificationCode">
            <el-input
              v-model="captcha"
              class="verificationCodeInput"
              placeholder="请输入验证码"
              prefix-icon="iconfont iconyanzhengma"
              clearable
              @keyup.enter.native="loginClickHandler"
            ></el-input>
            <img
              @click="changeCaptcha"
              class="verificationCodeImg"
              :src="verificationCodeImgSrc"
              alt=""
            />
          </div>
        </transition>
        <el-button
          class="login"
          type="primary"
          @click="loginClickHandler"
          :loading="loginLoading"
          >登录</el-button
        >
      </div>
    </transition>

    <div class="footer">
      <p>技术支持：东方世纪科技股份有限公司</p>
    </div>
  </div>
</template>

<script>
import * as THREE from 'three'
import { Water } from 'three/examples/jsm/objects/Water.js'
import { Sky } from 'three/examples/jsm/objects/Sky.js'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GUI } from 'three/examples/jsm/libs/dat.gui.module.js'
import { mapState, mapActions, mapMutations } from 'vuex'

// import { pages } from '@/config'

let container, camera, scene, renderer, controls, water, sun
export default {
  name: 'Login',
  data () {
    return {
      username: '',
      password: '',
      captcha: '',
      checked: '',
      timer: '',
      logoSrc: '../../assets/static/img/login/logo.png',
      systemName: '东方世纪用户权限管理平台 V1.0',
      showLoginBox: false,
      bgSrc: '../../static/img/login/bg.png',
      bgPicSrc: '../../static/img/login/bgPic.png',
    }
  },
  computed: mapState([
    'loaded',
    'loginLoading',
    'verificationCodeImgSrc',
    'showVerificationCode',
    'ak',
    'callbackUrl',
  ]),
  methods: {
    ...mapMutations(['changeCaptcha', 'setCallbackUrl']),
    ...mapActions(['pageLogin', 'otherSystemLogin', 'judgeCaptcha']),
    loginClickHandler () {
      let loginParams = {
        username: this.username,
        password: this.password,
        captcha: this.captcha,
      }
      if (this.$route.query.callbackUrl) {
        loginParams.callbackUrl = this.$route.query.callbackUrl
        this.otherSystemLogin(loginParams)
      } else {
        this.selfLogin(loginParams)
      }
    },
    // logo图片无效时，显示默认logo
    logoError () {
      this.logoSrc = '../../static/img/login/logo.png'
    },
    // 背景无效时，显示默认背景
    bgError () {
      this.bgSrc = '../../static/img/login/bg.png'
    },
    // 背景插图无效时，显示默认插图
    bgPicError () {
      this.bgPicSrc = '../../static/img/login/bgPic.png'
    },
    // 初始化登录背景
    initBg () {
      container = this.$refs.canvas

      renderer = new THREE.WebGLRenderer()
      renderer.setPixelRatio(window.devicePixelRatio)
      renderer.setSize(window.innerWidth, window.innerHeight)
      renderer.toneMapping = THREE.ACESFilmicToneMapping
      container.appendChild(renderer.domElement)

      scene = new THREE.Scene()

      camera = new THREE.PerspectiveCamera(
        55,
        window.innerWidth / window.innerHeight,
        1,
        20000
      )
      camera.position.set(30, 30, 100)

      //

      sun = new THREE.Vector3()

      // Water

      const waterGeometry = new THREE.PlaneGeometry(10000, 10000)

      water = new Water(waterGeometry, {
        textureWidth: 512,
        textureHeight: 512,
        waterNormals: new THREE.TextureLoader().load(
          '../../static/img/login/waternormals.jpg',
          function (texture) {
            texture.wrapS = texture.wrapT = THREE.RepeatWrapping
          }
        ),
        sunDirection: new THREE.Vector3(),
        sunColor: 0xffffff,
        waterColor: 0x001e0f,
        distortionScale: 3.7,
        fog: scene.fog !== undefined,
      })

      water.rotation.x = -Math.PI / 2

      scene.add(water)

      // Skybox

      const sky = new Sky()
      sky.scale.setScalar(10000)
      scene.add(sky)

      const skyUniforms = sky.material.uniforms

      skyUniforms['turbidity'].value = 10
      skyUniforms['rayleigh'].value = 2
      skyUniforms['mieCoefficient'].value = 0.005
      skyUniforms['mieDirectionalG'].value = 0.8
      var azimuth = -140
      const parameters = {
        elevation: 0,
        azimuth: azimuth,
      }

      const pmremGenerator = new THREE.PMREMGenerator(renderer)

      function updateSun () {
        const phi = THREE.MathUtils.degToRad(90 - parameters.elevation)
        const theta = THREE.MathUtils.degToRad(parameters.azimuth)

        sun.setFromSphericalCoords(1, phi, theta)

        sky.material.uniforms['sunPosition'].value.copy(sun)
        water.material.uniforms['sunDirection'].value.copy(sun).normalize()

        scene.environment = pmremGenerator.fromScene(sky).texture
      }
      updateSun()

      controls = new OrbitControls(camera, renderer.domElement)
      controls.maxPolarAngle = Math.PI * 0.495
      controls.target.set(0, 10, 0)
      controls.minDistance = 40.0
      controls.maxDistance = 200.0
      controls.enablePan = false
      controls.update()

      // GUI

      const gui = new GUI()

      const folderSky = gui.addFolder('Sky')
      folderSky.add(parameters, 'elevation', 0, 90, 0.1).onChange(updateSun)
      folderSky.add(parameters, 'azimuth', -180, 180, 0.1).onChange(updateSun)
      folderSky.open()

      const waterUniforms = water.material.uniforms

      const folderWater = gui.addFolder('Water')
      folderWater
        .add(waterUniforms.distortionScale, 'value', 0, 8, 0.1)
        .name('distortionScale')
      folderWater.add(waterUniforms.size, 'value', 0.1, 10, 0.1).name('size')
      folderWater.open()
      gui.domElement.style.display = 'none'

      //

      window.addEventListener('resize', this.onWindowResize)
    },
    onWindowResize () {
      camera.aspect = window.innerWidth / window.innerHeight
      camera.updateProjectionMatrix()

      renderer.setSize(window.innerWidth, window.innerHeight)
    },
    animate () {
      requestAnimationFrame(this.animate)
      this.render()
    },
    render () {
      // const time = performance.now() * 0.001

      water.material.uniforms['time'].value += 1.0 / 60.0

      renderer.render(scene, camera)
    },
    // 权限平台自身登录
    selfLogin (loginParams) {
      this.pageLogin(loginParams)
    },
  },
  mounted () {
    localStorage.removeItem('loaded')
    setTimeout(() => {
      this.showLoginBox = true
    }, 500)
    // if (this.loaded) {
    //   this.$router.push(pages.home.path)
    // } else {
    //   localStorage.clear()
    // }
    // this.initBg()
    // this.animate()
  },
  created () {
    this.judgeCaptcha({
      callbackUrl: this.$route.query.callbackUrl,
    })
    if (this.$route.query.callbackUrl) {
      this.setCallbackUrl(this.$route.query.callbackUrl)
      let callbackUrl = this.$route.query.callbackUrl
      let reg = new RegExp(/(\w+):\/\/([^/:]+)(:\d*)?/)
      this.logoSrc = callbackUrl.match(reg)[0] + '/static/logo.png'
      this.bgSrc = callbackUrl.match(reg)[0] + '/static/login-back.png'
      this.bgPicSrc = callbackUrl.match(reg)[0] + '/static/login-illustration.png'
    }
    this.$route.query.name &&
      (this.systemName = (unescape(this.$route.query.name) || '东方世纪用户权限管理平台 V1.0'))
    localStorage.getItem('platformId') && localStorage.removeItem('platformId')
  },
}
</script>

<style lang="less" scoped>
@import '../../assets/static/style/common';
#login {
  width: 100%;
  height: 100vh;
  position: relative;
  // #backgroundContainer {
  //   width: 100%;
  //   height: 100%;
  //   background: #000;
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  // }
  .bgContainer {
    width: 100%;
    height: 100%;
    min-width: 1920px;
    display: flex;
    align-items: center;
    position: relative;
    .bg {
      width: 100%;
      height: 75%;
    }
    .bgPic {
      position: absolute;
      left: 8%;
      width: 800px;
    }
  }
  .header {
    position: absolute;
    left: 100px;
    top: 40px;
    height: 70px;
    > img {
      width: 50px;
      vertical-align: middle;
      margin-right: 10px;
      -webkit-user-drag: none;
    }
    span {
      color: transparent;
      margin-left: 10px;
      user-select: none;
      font-size: 32px;
      vertical-align: middle;
      font-weight: bold;
      background-image: -webkit-linear-gradient(
        left,
        #a6fafa,
        #0486b1 25%,
        #02da92 50%,
        #0486b1 75%,
        #a6fafa
      );
      background-clip: text;
      -webkit-text-fill-color: transparent;
      background-size: 200% 100%;
      animation: masked-animation 3s ease-in-out infinite alternate;
    }
  }
  .loginBox {
    width: 310px;
    height: 408px;
    padding: 0 30px;
    background: rgba(0, 108, 112, 0.3);
    position: absolute;
    right: 200px;
    top: 240px;
    border-radius: 10px;
    box-shadow: 0 0 10px 0 deepskyblue;
    .username {
      /deep/.el-input__prefix {
        .iconfont {
          font-size: 20px !important;
          margin-right: 20px;
        }
      }
    }
    .password {
      /deep/.el-input__prefix {
        .iconfont {
          font-size: 20px !important;
          margin-right: 20px;
        }
      }
    }
    h3 {
      padding: 0;
      margin: 0;
      color: #04c4ff;
      font-weight: normal;
      text-align: center;
      font-size: 18px;
      line-height: 100px;
    }
    /deep/.el-input {
      margin-bottom: 20px;
      .el-input__inner {
        background: none;
        color: #fff;
        border: 1px solid rgb(5, 137, 155);
      }
    }
    .autoLogin {
      /deep/ .el-checkbox__label {
        color: @ec-color-text-label;
      }
    }
    .verificationCode {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .verificationCodeInput {
        width: 48%;
        vertical-align: middle;
      }
      .verificationCodeImg {
        width: 36%;
        margin-top: -20px;
        cursor: pointer;
        vertical-align: middle;
      }
    }
    .login {
      width: 100%;
      margin-top: 20px;
      background: linear-gradient(to bottom right, #ffa05b, #ff6e1f);
      color: #fff;
      font-size: 18px;
      border: none;
      transition: all 1s;
      opacity: 0.8;
      &:hover {
        background: linear-gradient(to bottom right, #ffb45b, #ff821f);
        opacity: 0.9;
      }
    }
  }
  .footer {
    width: 100%;
    min-width: 1600px;
    position: absolute;
    bottom: 50px;
    left: 0px;
    p {
      text-align: center;
      color: rgb(0, 0, 0);
      user-select: none;
    }
  }
  @keyframes masked-animation {
    0% {
      background-position: 0 0;
    }
    100% {
      background-position: -100% 0;
    }
  }
}
</style>
